module.exports = __webpack_public_path__ + "static/img/pagj_card_item_disabled_bg.13da142b.png";